export const ADMIN_SPACE_REPORT_SCREEN = 'spaceReportsSiteSettings';
